export enum DependencyName {
  CPRFetch = 'cpr_fetch',
  RealEstateLookup = 'real_estate_lookup',
  PaymentRemark = 'payment_remark',
}

export enum DependencyStatus {
  OK = 'ok',
  Failed = 'failed',
}

export type ExternalDependencyOutcome = Record<string, unknown>;

export interface Dependency {
  id: string;
  loan_application_id: string;
  dependency_name: DependencyName;
  target_id?: string;
  status?: DependencyStatus | null;
  outcome?: ExternalDependencyOutcome;
  completed_at?: string | null;
  created_at: string;
  updated_at: string;
}
